import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchFreeHubsForUser } from '../../../api/api_users';
import { addHubToSpace } from '../../../api/api_hubs';

const NewHub = () => {
    const { translations } = useLanguage();
    const navigate = useNavigate();
    const location = useLocation();
    const { space } = location.state;
    const [spaceId] = useState(space.id);
    const [linkedDevices, setLinkedDevices] = useState({ data: [] });

    useEffect(() => {
        const loadLinkedDevices = async () => {
            try {
                const devices = await fetchFreeHubsForUser();
                if (devices.data && Array.isArray(devices.data)) {
                    setLinkedDevices({ data: devices.data });
                } else {
                    setLinkedDevices({ data: [] });
                }
            } catch (error) {
                console.error('Failed to fetch devices:', error);
                setLinkedDevices({ data: [] });
            }
        };
        loadLinkedDevices();
    }, []);

    const handleBack = () => {
        navigate(-1);
    };

    const handleAddHub = async (hub_id) => {
        const token = localStorage.getItem('userToken');
        const confirmed = window.confirm(translations.add_hub_confirmation);

        if (confirmed) {
            try {
                const response = await addHubToSpace(hub_id, spaceId, token);
                if (response.error === false) {
                    navigate("/spaces/spaceManager");
                } else {
                    console.error('Error adding hub');
                }
            } catch (error) {
                console.error('Failed to add hub:', error);
            }
        } else {
            console.log('Hub addition cancelled.');
        }
    };

    const handleLinkNewDevice = () => {
        navigate("/fastActions/addHub");
    };

    return (
        <div className="sm-page">
            <div className="sm-container">
                <div className="header">
                    <button onClick={handleBack} className="back-button">&#8592;</button>
                    <h1>{translations.new_device}</h1>
                </div>
                <div className="vertical-stack-content">
                    <div className="sm-space-info2 centered-space-info">
                        <h2>{translations.linked_devices_list}</h2>
                        {linkedDevices.data.map((device, index) => (
                            <div key={index} className="content2">
                                <div className="general-button" onClick={() => handleAddHub(device.id)}>
                                    {device.name}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="bottom-center">
                        <button onClick={handleLinkNewDevice} className="general-button fastSettings-button">
                            {translations.link_new_device}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewHub;
